import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { buildWalletsGroup } from '../../_shared/images/wallets-group';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildBenefitLabel } from '../../_shared/pills/benefit-label';
import { buildPaymentMethodText } from '../../_shared/text/payment-method-text';
import { buildLimitText } from '../../_shared/text/limit-text';
import { buildLegales } from '../../_shared/text/legales';
import { buildBackgroundImage } from '../../_shared/images/background-image';

export const macroBeneficios1080x1920B: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1080,
      height: 1920,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    buildBackgroundImage({ canvasWidth: 1080, canvasHeight: 1920 }),
    {
      rx: 48,
      ry: 48,
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 920.9285,
      width: 150,
      height: 100,
      fill: 'rgb(255,255,255)',
      stroke: '#1e40af',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 8.6572,
      scaleY: 9.1747,
      angle: -89.7821,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    buildPillPair({
      left: { pieceId: 'category', text: 'GASTRONOMÍA', style: 'white-blue-stroke' },
      right: { pieceId: 'valid-days', text: 'Lunes a viernes', style: 'pink-white-text' },
      fontSize: 35,
      paddingX: 21.882,
      paddingY: 7.294,
      strokeWidth: 1.824,
      position: { left: 540, top: 446.4032, width: 632.4051, height: 54.7686 }
    }),
    buildPaymentMethodText({
      pieceId: 'payment-method-text',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 44,
      lineHeight: 1.06,
      textAlign: 'center',
      position: { left: 548.6357, top: 1038.4199, width: 605.2153, height: 102.4232 }
    }),
    buildDiscountValue({
      pieceId: 'discount-value',
      text: '20',
      fontSize: 493,
      position: { left: 540, top: 771.6369, width: 745.7472, height: 557.09 }
    }),
    buildBenefitLabel({
      pieceId: 'benefit-label',
      text: 'de ahorro',
      fontSize: 44,
      position: { left: 805.6353, top: 737.6196 },
      borderRadius: 31
    }),
    {
      fontSize: 77,
      fontWeight: 'bold',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 815.3342,
      top: 579.0351,
      width: 97.7724,
      height: 87.01,
      fill: '#0030eb',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },
    buildLimitText({
      pieceId: 'limit-text',
      text: 'Tope $10.000 por cliente, por semana.',
      position: { left: 540, top: 1293.9084, width: 625, height: 31.64 }
    }),
    buildWalletsGroup({ position: { left: 540, top: 1239.0344, height: 70 } }),

    {
      cropX: 0,
      cropY: 0,
      pieceId: 'brand-logo',
      imageFit: 'contain',
      imageBox: {
        width: 176,
        height: 176
      },
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 540,
      top: 1455,
      width: 400,
      height: 400,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.44,
      scaleY: 0.44,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: '',
      crossOrigin: null,
      filters: []
    },

    buildLegales({
      pieceId: 'legales',
      text: 'CARTERA CONSUMO',
      position: { left: 540, top: 1685.4892, width: 683, height: 30.51 }
    })
  ],
  background: '#fff',
  clipPath: {
    rx: 0,
    ry: 0,
    selectable: true,
    evented: true,
    lockMovementX: false,
    lockMovementY: false,
    lockScalingX: false,
    lockScalingY: false,
    lockRotation: false,
    objectCaching: true,
    type: 'Rect',
    version: '7.1.0',
    originX: 'left',
    originY: 'top',
    left: 0,
    top: 0,
    width: 1080,
    height: 1920,
    fill: 'rgb(0,0,0)',
    stroke: null,
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: false,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }
};
